import { CommonButton } from 'components/common/Forms/Button';
import React, { ReactElement } from 'react';
import {
  CalendarLeftControlsWrapper,
  CalendarMiddleControlsWrapper,
  CalendarPrevNextRangePickerWrapper,
  CalendarRightControlsWrapper,
  CalendarTopControlsWrapper,
  CalendarWeekViewButtonWrapper,
} from './calendar.styled';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { PrevNextWeekPicker } from '../../../InlineCalendar/PrevNextWeekPicker';
import { useMaxAndMinFutureDateForStaffBooking } from '../../../../hooks/patient/booking/useMaxAndMinFutureDateForBooking';
import { DateRangeType } from '../../../../types/calendar';
import { PrevNextDayPicker } from '../../../InlineCalendar/PrevNextDayPicker';
import { OverflowButton } from '../appointments/overflow/OverflowButton';

export interface CalendarHeaderUnderLineProps {
  selectedDate: Date;
  onSelectDate: (date: Date) => void;
  onOverflowClicked: () => unknown;
  dateRangeType: DateRangeType;
  setDateRangeType: (dateRangeType: DateRangeType) => void;
}

export const CalendarHeaderUnderLine = ({
  selectedDate,
  onSelectDate,
  onOverflowClicked,
  dateRangeType,
  setDateRangeType,
}: CalendarHeaderUnderLineProps): ReactElement => {
  const { t } = useCommonTranslation();

  const { maxDate, minDate } = useMaxAndMinFutureDateForStaffBooking();

  return (
    <CalendarTopControlsWrapper>
      <CalendarLeftControlsWrapper>
        <OverflowButton onOverflowClicked={onOverflowClicked} />
      </CalendarLeftControlsWrapper>
      <CalendarMiddleControlsWrapper>
        {dateRangeType === 'week' ? (
          <CalendarPrevNextRangePickerWrapper>
            <PrevNextWeekPicker
              selectedDate={selectedDate}
              onSelectDate={onSelectDate}
              maxDate={maxDate}
              minDate={minDate}
            />
          </CalendarPrevNextRangePickerWrapper>
        ) : (
          <>
            <CalendarPrevNextRangePickerWrapper>
              <PrevNextDayPicker
                selectedDate={selectedDate}
                onSelectDate={onSelectDate}
                maxDate={maxDate}
                minDate={minDate}
              />
            </CalendarPrevNextRangePickerWrapper>
            <CalendarWeekViewButtonWrapper>
              <CommonButton
                variant="secondary"
                onClick={() => setDateRangeType('week')}
              >
                {t('week-view')}
              </CommonButton>
            </CalendarWeekViewButtonWrapper>
          </>
        )}
      </CalendarMiddleControlsWrapper>
      <CalendarRightControlsWrapper />
    </CalendarTopControlsWrapper>
  );
};
